<router-outlet></router-outlet>
<p-toast position="bottom-center"></p-toast>
<shared-core-toast-container />
